export const USER_PREFERENCES = {
	SIDENAV_PINNED: 'sidenav_pinned',
	NAV_SHORTCUTS: 'nav_shortcuts',
	LAST_SEEN_CHANGELOG_VERSION: 'last_seen_changelog_version',
};
